// extracted by mini-css-extract-plugin
export default {"card":"ProductCard_card__MB+ob"};